<template>
    <ValidationProvider
        class="relative appearance-none"
        tag="div"
        :vid="vid"
        :rules="rules"
        :name="name"
        :mode="mode"
        v-slot="{ errors, required, ariaInput, ariaMsg }"
    >
        <button
            style="height:23px;padding:0 7px 0 7px"
            class=""
            :class="{ 'hasError': errors[0]}"
            :type="type"
            ref="button"
            @click.prevent="emitClick"
            v-model="innerValue"
            :disabled="disabled"
            v-beautify.literal="vBeautify"
            v-bind="ariaInput"
            v-tooltip.bottom-end="{
                content: !errors[0] ? '' : errText ,
                template: tooltipTemplate(),
            }"
        ><slot/></button>
    </ValidationProvider>
</template>

<script>
import { extend } from 'vee-validate';
extend('required',  {
    validate(value) {
        return {
            required: true,
            valid: ['', null, undefined].indexOf(value) === -1
        };
    },
    //TODO что это?)
    message: 'ыапжыврпыврпол!'
});
export default {
    props: {
        disabled: {
          type: Boolean,
          default: false
        },
        errText: {
          'type': String,
          'default': ''
        },
        vid: {
            type: String,
            default: undefined
        },
        name: {
            type: String,
            default: ""
        },
        mode: {
            type: String,
            default: "passive"
        },
        rules: {
            type: [Object, String],
            default: ""
        },
        placeholder: {
            type: String,
            default: ""
        },
        vBeautify: {
            default: '',
            type: String
        },
        type: {
            type: String,
            default: "text",
            validator(value) {
                return [
                    "url",
                    "text",
                    "password",
                    "tel",
                    "search",
                    "number",
                    "email"
                ].includes(value);
            }
        },
        value: {
            type: null,
            default: ""
        }
    },
    data: () => ({
        innerValue: ""
    }),
    computed: {
        hasValue() {
            return !!this.innerValue;
        }
    },
    methods: {
        emitClick () {
            this.$emit('click');
        },
      tooltipTemplate ()  {
          return `<div class="tooltip" role="tooltip"><div class="tooltip-arrow hasError"></div><div class="tooltip-inner hasError"></div></div>`;
      }
    },
    watch: {
        innerValue(value) {
            this.$emit("input", value);
        },
        value(val) {
            if (val !== this.innerValue) {
                this.innerValue = val;
            }
        }
    },
    created() {
        if (this.value) {
            this.innerValue = this.value;
        }
    }
};
</script>

<style lang="scss">

.tooltip-inner.hasError {
    text-shadow: none !important;
    border-color: #d04444 !important;
    background-color: #d04444 !important;
    box-shadow: 4px 4px 8px #dd4b3973 !important;
}
.tooltip-arrow.hasError {
    border-color: #d04444 !important;
}
</style>
